// **  Initial State
const toolState = {
  mahallalar: { cond: false, data: [] }
}
const MahallaReducer = (state = toolState, action) => {
  switch (action.type) {
    case "HANDLE_MAHALLALAR_ACTIONS":
      return { ...toolState, mahallalar: { cond: action.val, data: action.data } }
    default:
      return state
  }
}

export default MahallaReducer
